/**
 * Every URL ADR-0023's brand and royalty screens call, in one place — the
 * same discipline `Pages/MenuGovernance/menuGovernanceRoutes.ts` and
 * `Pages/Pricing/pricingRoutes.ts` keep, for the same reason: read directly
 * from `src/modules/brands/brands.controller.ts` and
 * `src/modules/royalty/royalty.controller.ts` on the backend rather than a
 * summary, so a rename there is a one-file fix here instead of a hunt through
 * five screens.
 */

/** A tenant's brands. `GET`/`POST`, then `GET`/`PATCH`/`DELETE` per id. */
export const BRANDS = '/brands';

export function brandPath(brandId: string): string {
  return `${BRANDS}/${brandId}`;
}

export function brandStandardsPath(brandId: string): string {
  return `${brandPath(brandId)}/standards`;
}

export function brandBranchesPath(brandId: string): string {
  return `${brandPath(brandId)}/branches`;
}

export function brandBranchPath(brandId: string, branchId: string): string {
  return `${brandBranchesPath(brandId)}/${branchId}`;
}

export function brandAnalyticsPath(brandId: string): string {
  return `${brandPath(brandId)}/analytics/query`;
}

export function brandTemplatesPath(brandId: string): string {
  return `${brandPath(brandId)}/onboarding-templates`;
}

export function brandTemplatePath(brandId: string, templateId: string): string {
  return `${brandTemplatesPath(brandId)}/${templateId}`;
}

export function brandOnboardPath(brandId: string): string {
  return `${brandPath(brandId)}/onboard`;
}

/** `RoyaltyController` is mounted under the brand it belongs to — ADR-0023 §7. */
export function royaltySchemesPath(brandId: string): string {
  return `${brandPath(brandId)}/royalty/schemes`;
}

export function royaltySchemePath(brandId: string, schemeId: string): string {
  return `${royaltySchemesPath(brandId)}/${schemeId}`;
}

export function royaltyStatementsPath(brandId: string): string {
  return `${brandPath(brandId)}/royalty/statements`;
}

/** Where the rail sends someone to run this feature. */
export const BRANDS_ROUTE = '/brands';
